export enum ModeleTheme {
  Uploaded = 0,
  Participant = 4,
  ConvocationsFormateurs = 6,
  Emargement = 1,
  Factures = 3,
  Convention = 5,
}
export enum ModeleThemeWhithoutUpload {
  Participant = 4,
  ConvocationsFormateurs = 6,
  Emargement = 1,
  Factures = 3,
  Convention = 5,
}
